module.exports = __webpack_public_path__ + "img/donbler-logo-yellow-icononly.53458d69.svg";